import { AnnouncementsActionTypes } from '../../actions/announcements/announcements.actions';
import { ListCardItem } from 'src/app/shared/components/cards/list-card/models/ListCardItem';

export interface AnnouncementsState {
  announcements: ListCardItem[];
  totalCount: string;
  announcement: ListCardItem;
  announcementsLoading: boolean;
  announcementLoading: boolean;
}

export const initialState: AnnouncementsState = {
  announcements: [],
  totalCount: null,
  announcement: null,
  announcementsLoading: false,
  announcementLoading: false,
};

export function announcementsReducer(
  state: AnnouncementsState = initialState,
  action: any
): AnnouncementsState {
  switch (action.type) {
    case AnnouncementsActionTypes.GET_ANNOUNCEMENTS:
      return {
        ...state,
        announcementsLoading: true
      };
    case AnnouncementsActionTypes.GET_ANNOUNCEMENTS_SUCCESS:
      return {
        ...state,
        announcementsLoading: false,
        announcements: [...state.announcements, ...action.announcements],
        totalCount: action.totalCount
      };
    case AnnouncementsActionTypes.CLEAR_ANNOUNCEMENTS:
      return {
        ...state,
        announcementsLoading: false,
        announcements: []
      };
    case AnnouncementsActionTypes.GET_ANNOUNCEMENT:
      return {
        ...state,
        announcementLoading: true
      };
    case AnnouncementsActionTypes.GET_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        announcement: action.announcement,
        announcementLoading: false
      };
    case AnnouncementsActionTypes.CLEAR_ANNOUNCEMENT:
      return {
        ...state,
        announcementLoading: false,
        announcement: null
      };
    default:
      return state;
  }
}
